var jagdfieber = {


	navigationHelper: function() {

		$( '.off-canvas-toggle' ).unbind( 'click' ).click( function() {
			$( 'body' ).toggleClass( $( this ).data( 'toggle' ) );
		} );

		// show sub-menu on hover
		$( '.main-navigation a[href="#"]' ).click( function( e ) {
			e.preventDefault();
		} );

	},

	SlickSlider: function() {
		
		typeof useSlick != 'undefined' && $( '.slider' ).slick();

	},

	Fancybox: function() {
		
		typeof useFancybox != 'undefined' && $( '.fancybox' ).fancybox();

	},

	SafariHelpers: function() {

		var isSafari = /constructor/i.test(window.HTMLElement);
		isSafari && $( 'body' ).addClass( 'safari-needs-some-help' );

	},

	init: function() {
		this.navigationHelper();
		this.SlickSlider();
		this.Fancybox();
		this.SafariHelpers();
	}

}

$( function() {
	'use strict';

	jagdfieber.init();

} );